var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._b({ref:"textarea",staticClass:"input TEXTAREA",style:({ height: `${_vm.initialHeight}px` }),domProps:{"value":_vm.value},on:{"focus":_vm.resizeTextarea,"blur":_vm.resizeTextarea,"input":_vm.onTextareaInput}},'textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }